import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ActivitiesPage from "./pages/ActivitiesPage";
import LivestockLessonsPage from "./pages/LivestockLessonsPage";
import BarbadosOrderPage from "./pages/BarbadosOrderPage";
import WhereToBuyPage from "./pages/WhereToBuyPage";
import ReadingGroupKitPage from "./pages/ReadingGroupKitPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import InvoicePage from "./pages/InvoicePage";
import ManualOrderPage from "./pages/ManualOrderPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import AdminInventoryPage from "./pages/AdminInventoryPage";
import AdminTestimonialsPage from "./pages/AdminTestimonialsPage";
import AdminBarbadosReservationsPage from "./pages/AdminBarbadosReservationsPage";

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen flex flex-col">
      {!isAdminPage && <Header />}
      <main className="flex-1">{children}</main>
      {!isAdminPage && <Footer />}
      {!isAdminPage && <BackToTop />}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/lessons" element={<LivestockLessonsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<BlogPostPage />} />
            <Route path="/activities" element={<ActivitiesPage />} />
            <Route path="/order/barbados" element={<BarbadosOrderPage />} />
            <Route path="/where-to-buy" element={<WhereToBuyPage />} />
            <Route path="/reading-group-kit" element={<ReadingGroupKitPage />} />
            <Route path="/reviews" element={<TestimonialsPage />} />
            <Route path="/invoice/:orderNumber" element={<InvoicePage />} />
            {/* International direct ordering disabled — redirect to retailer search */}
            <Route path="/order" element={<Navigate to="/where-to-buy" replace />} />
            <Route path="/order/confirmation/*" element={<Navigate to="/where-to-buy" replace />} />
            <Route path="/payment/*" element={<Navigate to="/where-to-buy" replace />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/orders"
              element={
                <ProtectedRoute>
                  <AdminOrdersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/barbados-reservations"
              element={
                <ProtectedRoute>
                  <AdminBarbadosReservationsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/orders/new"
              element={
                <ProtectedRoute>
                  <ManualOrderPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/orders/:orderNumber/edit"
              element={
                <ProtectedRoute>
                  <ManualOrderPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/inventory"
              element={
                <ProtectedRoute>
                  <AdminInventoryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/testimonials"
              element={
                <ProtectedRoute>
                  <AdminTestimonialsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/invoice/:orderNumber"
              element={
                <ProtectedRoute>
                  <InvoicePage adminMode={true} />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
